import { Icon, Heading3Med, IIconNames } from '@hai/ui-react';
import classNames from 'classnames';
import React from 'react';

import { generateDataAuto } from 'src/js/util/automation';
import { StreamViewModel } from '../streaming/stream/stream-models';
import { HeaderStatsRow } from '../streaming/header-stats-row';

interface Props {
  className?: string;
  color?: string;
  icon?: IIconNames;
  leftBar?: boolean;
  title?: string;
  streamData?: StreamViewModel;
}

export const FullHeader: React.FunctionComponent<Props> = ({ className, color, leftBar, icon, title, streamData }) => {
  return (
    <div className={classNames('full-page-header', className)} data-auto={generateDataAuto('full', 'header srt')}>
      {leftBar && (
        <div
          className="status-indicator"
          style={{ backgroundColor: color }}
          data-auto={generateDataAuto('header', 'status indicator')}
        />
      )}
      <Icon iconname={icon} style={{ fill: color }} size={'md'} />
      <Heading3Med className="header-title fs-mask" data-auto={generateDataAuto('header', 'stream title')}>
        {title}
      </Heading3Med>
      <HeaderStatsRow data={streamData} classPrefix="stream" />
    </div>
  );
};
